<template>
    <div id="video">
        <router-view />
    </div>
</template>

<script>
import VideoList from "./VideoList";
import VideoDetail from "./VideoDetail";

export default {
    name: "Video",
    components: { VideoList, VideoDetail },
    data() {
        return {
            userId: localStorage.getItem("userId") || ""
        };
    },

    mounted() {
        this.addDataBuried();
    },
    methods: {
        addDataBuried() {
            let headers = {
                equipmentType: "3", //设备类型： 1：安卓、  2 ：IOS 、 3 ： H5
                phoneModel: "", //手机型号
                appVersionNumber: "" //app版本号
            };
            this.$axios
                .post(
                    "/SD/statistic/addDataBuried",
                    this.$qs.stringify({
                        usergid: this.userId,
                        moduleType: "11",
                        subModuleType: "3",
                        locationType: "1",
                        disMobile: "PC"
                    }),
                    {
                        headers
                    }
                )
                .then(res => {});
        }
    }
};
</script>
